<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
    <path d="M4.07031 0.771484C4.19623 0.809522 4.31998 0.90418 4.41797 1.04688C4.52188 1.19837 4.55078 1.33676 4.55078 1.38379C4.55078 1.38954 4.55065 1.39562 4.55078 1.40137C4.58365 2.81128 4.90626 4.19967 5.49902 5.48145C6.09182 6.76329 6.94269 7.91174 7.99805 8.85645C9.05327 9.80093 10.2914 10.5222 11.6367 10.9766C12.1837 11.1613 12.5794 11.3671 12.8408 11.5645C13.1067 11.7652 13.1837 11.9183 13.2021 11.9893C13.213 12.0311 13.2239 12.1065 13.1191 12.2529C13.0002 12.4189 12.7501 12.643 12.29 12.8848C11.1395 13.4895 9.85513 13.8035 8.55176 13.7979C8.54655 13.7978 8.54134 13.7978 8.53613 13.7979C6.508 13.8327 4.54977 13.0697 3.09082 11.6787C1.63473 10.2903 0.79382 8.38903 0.75 6.3916C0.773604 4.8437 1.28445 3.34056 2.21191 2.0918C3.26406 0.675255 3.89484 0.718587 4.07031 0.771484Z" stroke="black" stroke-width="1.5" stroke-linejoin="round"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconMoon'
}
</script>
